<template>
    <div class="hero__content">
        <video autoplay muted loop class="hero__deco" v-if="hero_is_video" :poster="home_hero_mobile_image">
            <source :src="home_hero_mobile_video" type="video/mp4">
        </video>
        <img v-else class="hero__deco" :src="home_hero_mobile_image" alt="Offerta Speciale per i nuovi soci ; Diventa socio Altroconsumo 2€ per 2 mesi ; Compila il form e scegli un Regalo di Benvenuto ; Puoi scegliere tra questi e tantissimi altri premi! ; Philips - MONT BLANC - Calvin Klein - BOSCH - Moulinex - Polaroid - JBL - HUAWEI - D&G - Moschino - Sony - Hugo BOSS">
        <slot></slot>
    </div>
</template>

<script>
import image_mixin from "../../_commons/fr/mixins/image_mixin";

export default {
    name: "HomeHero",
    mixins: [
        image_mixin
    ]
}
</script>

<style scoped>

</style>
